export enum DeviceType3D {
    SOLAR_PANEL = 'solarpanel',
    BATTERY = 'battery',
    GRID = 'grid',
    STOREY = 'storey',
    OTHER = 'other',
    METER = 'meter',
}

export enum StoreyType3D {
    STOREY_1 = 'STOREY_1',
    STOREY_2 = 'STOREY_2',
    STOREY_3 = 'STOREY_3',
    STOREY_4 = 'STOREY_4',
}

export enum ConnectedDeviceEnum {
    ERL = 'ERL',
    ERL_GEN2 = 'ERL_GEN2',
    STREAM_CONNECT = 'STREAM_CONNECT',
    STOREY = 'STOREY',
    STREAM_METER = 'STREAM_METER',
    LEGRAND_CONTACTOR = 'LEGRAND_CONTACTOR',
}

export enum PanelType {
    PLAY_MAX = 'PLAY_MAX',
    PLAY = 'PLAY',
    CITY = 'CITY',
}

export enum DeviceFilter {
    ALL = 'ALL',
    SOLAR_STORAGE = 'SOLAR_STORAGE',
    ACCESSORIES = 'ACCESSORIES',
}

export enum ConnectedDeviceDefaultName {
    STREAM_CONNECT = 'STREAMConnect',
    STOREY = 'STOREY',
    ERL = 'ERL v1',
    ERL_GEN2 = 'STREAM Link',
    STREAM_METER = 'METER',
    LEGRAND_CONTACTOR = 'TAP',
    PLAY_MAX = 'Sunology PM',
    PLAY = 'Sunology P2',
    CITY = 'Sunology CITY',
}

export type DeviceType = PanelType | ConnectedDeviceEnum;
export const DeviceTypeEnum = { ...PanelType, ...ConnectedDeviceEnum };

export type AllDevices = DeviceFilter | DeviceType;
